import { IntlShape } from "react-intl";
import { IDateTimeBox } from "cayo.ui";
import { OneTimeSchedule, Schedule } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import messages from "./messages";
import { nameofFactory } from "@cayo/shared/utils/object";
import { formComponentTypes } from "../Form/renderers/form-renderers";

const oneTimeNames = nameofFactory<OneTimeSchedule>();

const ONE_MINUTE_IN_MS = 60000;

const oneTimeForm = (intl: IntlShape, schedule?: Schedule) => {
  const result = {
    title: intl.formatMessage(messages.oneTime),
    items: [
      {
        type: "datetimebox" as formComponentTypes,
        label: intl.formatMessage(messages.startDate),
        autoFocus: true,
        required: true,
        readOnly: schedule?.readОnly,
        name: oneTimeNames("startDateTime"),
        showTimeZoneInfo: true,
        value:
          (schedule as OneTimeSchedule)?.startDateTime ||
          new Date(new Date().getTime() + ONE_MINUTE_IN_MS),
      } as IDateTimeBox,
    ] as IFormField[],
  };

  return result;
};

export default oneTimeForm;
